import { render } from "./TicketsDueChart.vue?vue&type=template&id=66bdc150&ts=true"
import script from "./TicketsDueChart.vue?vue&type=script&lang=ts"
export * from "./TicketsDueChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__